<template>
    <div>
          <div class="card" v-if="loaded">
              <div class="card-header">
                  <p class="card-header-title">{{character}}</p>
              </div>
              <div class="card-content">
                  <h5 class="title is-5 has-text-grey-dark">Puntos de nivel disponibles: <b><span class="has-text-info">{{points}}</span></b></h5>
                  <hr>
            <!-- STRENGTH FIELD -->
            <div class="field is-horizontal">
                <div class="field-label is-normal">
                    <label class="label">Fuerza</label>
                </div>
                <div class="field has-addons">
                    <p class="control">
                        <span class="button is-static">
                            {{stats.str}}
                        </span>
                    </p>
                    <p class="control is-expanded">
                        <input class="input" type="text" 
                        placeholder="Agregar puntos en Fuerza" 
                        v-model="form.strength"
                        name="fuerza"
                        v-validate="'numeric|min_value:1'">
                    </p>
                </div>
            </div>
            <!-- DEXTERITY FIELD -->
            <div class="field is-horizontal">
                <div class="field-label is-normal">
                    <label class="label">Agilidad</label>
                </div>
                <div class="field has-addons">
                    <p class="control">
                        <span class="button is-static">
                            {{stats.agi}}
                        </span>
                    </p>
                    <p class="control is-expanded">
                        <input class="input" type="text" 
                            placeholder="Agregar puntos en Agilidad" 
                            v-model="form.dexterity"
                            name="agilidad"
                            v-validate="'numeric|min_value:1'">
                    </p>
                </div>
            </div>
            <!-- VITALITY FIELD -->
            <div class="field is-horizontal">
                <div class="field-label is-normal">
                    <label class="label">Vitalidad</label>
                </div>
                <div class="field has-addons">
                    <p class="control">
                        <span class="button is-static">
                            {{stats.vit}}
                        </span>
                    </p>
                    <p class="control is-expanded">
                        <input class="input" type="text" 
                            placeholder="Agregar puntos en Vitalidad" 
                            v-model="form.vitality"
                            name="vitalidad"
                            v-validate="'numeric|min_value:1'">
                    </p>
                </div>
            </div>
            <!-- ENERGY FIELD -->
            <div class="field is-horizontal">
                <div class="field-label is-normal">
                    <label class="label">Energía</label>
                </div>
                <div class="field has-addons">
                    <p class="control">
                        <span class="button is-static">
                            {{stats.ene}}
                        </span>
                    </p>
                    <p class="control is-expanded">
                        <input class="input" type="text" 
                            placeholder="Agregar puntos en Energía" 
                            v-model="form.energy"
                            name="energia"
                            v-validate="'numeric|min_value:1'">
                    </p>
                </div>
            </div>
            <div class="content" v-if="errors.items.length > 0">
                <ul>
                    <li v-for="i in errors.items" :key="i.id" class="has-text-danger">{{i.msg}}</li>
                </ul>
            </div>

            <article class="message is-info">
            <div class="message-body">
                Recuerda mantener tu cuenta desconectada del juego para que los cambios surtan efecto.
            </div>
            </article>

              </div>
              <footer class="card-footer">
                <a @click="$emit('go-back')" class="card-footer-item has-text-link">Volver</a>
                <a  class="card-footer-item has-text-success"
                    @click="verifyForm()"
                    v-if="points>0">Agregar</a>
                <p class="card-footer-item" v-else>
                    <span>
                        No tienes puntos disponibles.
                    </span>
                </p>
              </footer>
          </div>
          <fa v-else icon="circle-notch" class="fa-4x has-text-white" spin/>
    </div>
</template>

<script>
import authHeader from '@/services/auth-header.js';
import Swal from 'sweetalert2'
export default {
    name:'CharacterStats',
    props: {
        api: String,
        user: Object
    },
    data:()=>({
        points: 0,
        total: 0,
        stats: {
            str:0,
            agi:0,
            vit:0,
            ene:0
        },
        form: {
            strength: '',
            dexterity: '',
            vitality: '',
            energy: '',
            leveluppoint:0
        },
        loaded: false
    }),
    async created() {
        await this.setUpStats()
        this.loaded = true
    },
    watch: {
        character: function() {
            this.setUpStats()
        }
    },
    computed: {
        endpoint() {
            return this.$store.getters.GetEndpoints.dashboard.server.stat
        },
        character() {
            return this.$store.getters.GetDashboardData.character
        }
    },
    methods: {
        async setUpStats() {
            this.loaded = false
            
            var path = this.api+this.endpoint+this.character
            let {data} = await this.$http.get(path, {headers:authHeader()})

            await this.makeStats(data)
            
            this.loaded = true
        },
        makeStats(data) {
            this.stats.str = data.strength
            this.stats.agi = data.dexterity
            this.stats.vit = data.vitality
            this.stats.ene = data.energy
            this.points = data.leveluppoint
        },
        verifyForm() {
            this.$validator.validate().then(isValid => {
                if (isValid) {
                    Swal.fire({
                            title: '¿Esta completamente seguro que desea agregar estos puntos?',
                            icon: 'question',
                            showCancelButton: true,
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#d33',
                            cancelButtonText: "No, espera!",
                            confirmButtonText: "Si, agregarlos!"
                        }).then((result) => {
                            if(result.value) {
                                if (this.checkStats()) {
                                    this.updateStats()
                                }
                                
                            }
                        })
                }
            })

        },
        checkStats() {
            this.errors.items = []

            if(this.form.strength == '' && this.form.dexterity == '' && this.form.vitality == '' && this.form.energy == '') {
                this.errors.items.push({id:106, vmId: this.errors.vmId, msg:'Debe agregar al menos 1 punto en algún un campo.'})
                return false
            }

            this.total = parseInt(this.form.strength != '' ? this.form.strength:'0') + 
                        parseInt(this.form.dexterity != '' ? this.form.dexterity:'0') +
                        parseInt(this.form.vitality != '' ? this.form.vitality:'0') +
                        parseInt(this.form.energy != '' ? this.form.energy:'0')
            //Total verification
            if(this.total > this.points) {
                this.errors.items.push({id:101, vmId: this.errors.vmId, msg:'No tienes puntos suficientes para agregar esta cantidad.'})
                return false
            } else if(this.total === 0) {
                this.errors.items.push({id:107, vmId: this.errors.vmId, msg:`No puede agregar ${this.total} puntos.`})
                return false
            }

            //Partial verification
            if(this.stats.str+parseInt(this.form.strength) > 32767) {
                this.errors.items.push({id:102, vmId: this.errors.vmId, field: "fuerza", msg:'Los puntos que quieres agregar en Fuerza superan el límite permitido de 32767.'})
                return false
            } else if (this.stats.agi+parseInt(this.form.dexterity) > 32767) {
                this.errors.items.push({id:103, vmId: this.errors.vmId, field: "agilidad", msg:'Los puntos que quieres agregar en Agilidad superan el límite permitido de 32767.'})
                return false
            } else if (this.stats.vit+parseInt(this.form.vitality) > 32767) {
                this.errors.items.push({id:104, vmId: this.errors.vmId, field: "vitalidad", msg:'Los puntos que quieres agregar en Vitalidad superan el límite permitido de 32767.'})
                return false
            } else if (this.stats.ene+parseInt(this.form.energy) > 32767) {
                this.errors.items.push({id:105, vmId: this.errors.vmId,  field: "energia", msg:'Los puntos que quieres agregar en Energía superan el límite permitido de 32767.'})
                return false
            }

            return true
        },
        async updateStats() {
            const formData = this.getFormData()
            var path = this.api+this.endpoint+this.character+'/'
            this.$store.commit('setLoader', true)
            await this.$http.put(path, formData, {headers:authHeader()})
                .then(response=>{
                    var result = response.data
                    this.makeStats(result)
                    this.resetForm()
                    Swal.fire({
                        position: 'top',
                        icon: 'success',
                        title: `Se han agregado los puntos correctamente!`,
                        showConfirmButton: false,
                        timer: 3000,
                        showClass: {
                            popup: 'animated fadeInDown faster'
                        },
                        hideClass: {
                            popup: 'animated fadeOutUp faster'
                        }
                    })
                })
                .catch(serverError => {
                    var result = serverError.response.data
                    var message = ''
                    if (result.status_code==403) message = 'Tu cuenta debe permanecer desconectada del juego para procesar tus puntos.'
                    Swal.fire({
                        icon: 'error',
                        title: 'Ops, Ha ocurrido un error!',
                        text: message,
                        showConfirmButton: true
                    })
                })
            this.$store.commit('setLoader', false)
        },
        getFormData() {
            const formData = {
                strength: this.stats.str+parseInt(this.form.strength != '' ? this.form.strength:'0'),
                dexterity: this.stats.agi+parseInt(this.form.dexterity != '' ? this.form.dexterity:'0'),
                vitality: this.stats.vit+parseInt(this.form.vitality != '' ? this.form.vitality:'0'),
                energy: this.stats.ene+parseInt(this.form.energy != '' ? this.form.energy:'0'),
                leveluppoint: this.points-this.total
            }
            return formData
        },
        resetForm() {
            this.form.strength = ''
            this.form.dexterity = ''
            this.form.vitality = ''
            this.form.energy = ''
            this.form.leveluppoint = 0 
        }
    }
}
</script>

<style>

</style>